exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".twitter-x {\n  enable-background:new 0 0 1668.56 1221.19;\n}\n\n.twitter-x-st0 {\n  stroke:#FFFFFF;\n  stroke-miterlimit:10;\n}\n\n.twitter-x-st1 {\n  fill:#FFFFFF;\n}\n\n", ""]);
